module.exports = __webpack_public_path__ + "img/rus.0cacf46e.svg";